const Bill_view = () => {
  return (
    <div>
      <h2>지출/청구 상세페이지</h2>
    </div>
  );
};

export default Bill_view;
